@if (universityRatingStats() && universityRatingStats()?.stars) {
	<div class="w-full mx-auto bg-white rounded-md">
		<div class="flex items-center justify-between pb-8">
			<div>
				<h2 class="secondary-header !mb-0">Student Reviews</h2>
				@if (totalReviews() && (totalReviews() ?? 0) > 0) {
					<p class="text-sm text-gray-900">
						Based on total {{ totalReviews() }} reviews
					</p>
				}
			</div>
			@if (totalReviews() && (totalReviews() ?? 0) >= 10) {
				<div class="flex-shrink-0">
					<p
						class="px-5 py-3 text-sm font-bold text-white rounded-lg bg-uc-blue-900"
					>
						{{ universityRating() | number: '1.2-2' }} / 5
					</p>
				</div>
			}
		</div>
		<!-- reviews overall score bars -->
		<div class="pb-6 space-y-3">
			@for (star of reversedStars; track star; let i = $index) {
				<div class="flex justify-between w-full gap-2">
					<div class="text-left whitespace-nowrap">
						{{ reversedStars.length - i }} star
					</div>
					<div class="w-full bg-gray-100 h-5 rounded-md mt-0.5 overflow-hidden">
						@if (star) {
							<div
								class="h-5 bg-yellow-500"
								[ngStyle]="{ width: star.value + '%' }"
							></div>
						}
					</div>
					<div class="text-right">{{ star.value | number: '1.0-0' }}%</div>
				</div>
			}
		</div>
	</div>
}

<!-- cta to write review -->
<div class="py-6 border-y sm:pt-8 sm:border-none">
	<p class="mb-1 text-lg font-medium">Write a review!</p>
	<p class="mb-4 text-sm font-medium text-gray-500">
		Students appreciate unbiased university reviews
	</p>
	<uc-write-review-btn
		[universityId]="uniId()"
		[universityUrl]="universityUrl()"
		[universityName]="uniName()"
		customStyles="block w-full secondary-button only-tab-focus !no-underline"
	/>
</div>
